<template>
  <div class="flex flex-col justify-center items-start px-[16px] md:p-0 md:mt-[30px] max-w-[450px] mx-auto">
    <h1 class="text-[#003F82] mt-[56px] [text-left text-[30px] leading-[28px] font-bold">
      Track and report side effects
    </h1>
    <div class="text-[#003F82] text-[16px] text-left w-full mt-[24px]">
      It’s very normal to experience side effects when taking GLP-1 medication, especially when you first start or when
      your dose increases. The good news is that these side effects usually improve over time as your body adjusts.
    </div>
    <div class="text-[#003F82] text-[16px] text-left w-full mt[24px]">
      If you are experiencing side effects, we can help. Share symptoms you are currently experiencing using this quick
      consultation.
    </div>
    <div class="bg-[#F6F9FC] mt-[24px] leading-[28px] border-l-4 border-[#2772DB] rounded p-10 flex items-start gap-3">
      <InformationIcon class="w-30 h-30 text-[#003F82]" />
      <p class="text-[#003F82] text-left text-[16px] font-bold">
        Please note that MedExpress is not an emergency service. If you develop sudden, severe or serious side effects,
        such as difficulty breathing, swelling of lips, tongue and/or throat swelling, difficulty swallowing, rapid
        heartbeat, chest pain or severe abdominal pain that may radiate to your back, seek urgent medication attention
        or call 999.
      </p>
    </div>

    <button
      class="mt-[56px] mb-[56px] h-[70px] text-[18px] font-medium w-full md:w-[414px] primary-btn"
      v-on:click="start()"
    >
      <div class="flex justify-center items-center">
        <span>Continue</span>
        <amp-img class="share-icons" src="/resources/img/icons/white_right_arrow.svg" alt="" width="26" height="16" />
      </div>
    </button>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from "vue";
import InformationIcon from "../../../../../resources/information.svg?inline";

export default Vue.extend({
  components: {
    InformationIcon,
  },
  props: {
    start: {
      type: Function as PropType<() => void>,
      required: true,
    },
  },
});
</script>

<style scoped>
@tailwind utilities;
@tailwind components;
</style>
